import { FileChit } from 'ui/molecules/FileChit';
import { MAX_FILE_CHITS_VIEWABLE } from 'stores/metadata';
import { FileType } from 'utils/file-utils';

import { ReactComponent as FileChitIconOverflow } from './icon-overflow.svg';

import './file-chit-row.css';

export type FileChitRowProps = {
  size?: 'default' | 'small';
  files: FileType[];
  limit?: number;
  onSelectFileClick?: any;
  isEditable?: boolean;
};

export const FileChitRow = ({
  size = 'default',
  files = [],
  limit = MAX_FILE_CHITS_VIEWABLE,
  onSelectFileClick,
  isEditable = false,
}: FileChitRowProps) => {
  if (!files.length) {
    return <></>;
  }

  let fileChitsToDisplay: FileType[];
  const shouldDisplayOverflowChit = files.length > limit;

  if (shouldDisplayOverflowChit) {
    fileChitsToDisplay = files.slice(0, limit);
  } else {
    fileChitsToDisplay = files;
  }

  return (
    <section data-testid="file-chit-row" className={`file-chit-row ${size}`}>
      {fileChitsToDisplay.map((file) => {
        return (
          <FileChit
            key={crypto.randomUUID()}
            file={file}
            isEditable={isEditable}
          />
        );
      })}
      {shouldDisplayOverflowChit && (
        <OverflowChit
          onSelectFileClick={onSelectFileClick}
          amount={Math.abs(files.length - limit)}
        />
      )}
    </section>
  );
};

export const OverflowChit = ({ amount, onSelectFileClick }) => {
  const descriptionText = `${amount} additional file${amount > 1 ? 's' : ''}`;

  return (
    <button
      className="file-chit"
      data-testid="overflow-chit"
      onClick={onSelectFileClick}
    >
      <div className="file-icon processing">
        <FileChitIconOverflow />
      </div>
      <div className="file-information">
        <div className="file-name">{descriptionText}</div>
      </div>
    </button>
  );
};
